function noZeroQuantity(quantityContainer) {
  const quantityInput = quantityContainer.querySelector('.quantity-minus');
  let input = quantityContainer.querySelector('.quantity-input-wrapper input')
  quantityInput.addEventListener('click', function() {
  if (parseInt(input.value) < 1) {
    input.value = 1;
  }});
}
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");
        const originalButtonText =
          this.submitButton.querySelector("span").textContent;
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });

            this.submitButton.querySelector("span").textContent =
              "Added to cart!";
            setTimeout(() => {
              this.submitButton.querySelector("span").textContent =
                originalButtonText; // Bring back the original text after 2 seconds
            }, 2000);
            const quantityContainer = document.querySelector(
              ".quantity-selector-container"
            );
            if (quantityContainer) {
              if (!this.submitButton.classList.contains("quick-add__submit"))
              {
                quantityContainer.style.display = "block";
                this.submitButton.style.display = "none";
                noZeroQuantity(quantityContainer);
                let targetLabel = document.querySelectorAll('.product-form__input--pill label');
                if (targetLabel.length === 0) {
                  targetLabel = document.querySelectorAll('.color-swatches label');
                }
                for (let label of targetLabel){
                    label.addEventListener('click', function() {
                      quantityContainer.style.display = "none";
                      quantityContainer.querySelector('input').value = 1;
                      document.querySelector('.buy-button-main').style.display = "block";    
                });
              } 
              const quantityMinusButtons = document.querySelectorAll(".quantity-minus");
              const quantityPlusButtons = document.querySelectorAll(".quantity-plus");
            
              let timeoutId = null;
              function handleQuantityChange(productForm) {
                clearTimeout(timeoutId);
            
                timeoutId = setTimeout(() => {
                  const quantityInput = productForm.querySelector('input[name="quantity"]');
                  const newQuantity = parseInt(quantityInput.value);
                  const hiddenInput = formData.get("id");
                
                  let updates = {
                    [hiddenInput]: newQuantity,
                  };
            
                  // Make the fetch call to update the quantity using the stored line number
                  fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                      updates,
                    }),
                  })
                    .then((response) => response.json())
                    .then((data) => {
                      // ... (handle the updated cart data)
                    })
                    .catch((error) => {
                      // ... (handle errors)
                    });
                }, 300);
              }
            
              quantityMinusButtons.forEach((button) => {
                if (button.classList.contains("listener-added")){
                  }else{
                  button.classList.add("listener-added");
                  button.addEventListener("click", () => {
                    const productForm = button.closest(".product-form");
                    const quantityInput = productForm.querySelector('input[name="quantity"]');
                    let quantity = parseInt(quantityInput.value);
              
                    if (quantity > 0) {
                      quantity--;
                      quantityInput.value = quantity;
                    }
              
                    handleQuantityChange(productForm);
                  });
                }
              });
            
                quantityPlusButtons.forEach((button) => {
                  if (button.classList.contains("listener-added")){
                  }else{
                    button.classList.add("listener-added");
                    button.addEventListener("click", () => {
                      const productForm = button.closest(".product-form");
                      const quantityInput = productForm.querySelector('input[name="quantity"]');
                      let quantity = parseInt(quantityInput.value);
                      quantity++;
                      quantityInput.value = quantity;
                      handleQuantityChange(productForm);
                    
                    });
                  }
                });
              
              }
            }
            // Process the cart data here
            console.log(response);

            this.error = false;
            const delayBeforeClosingModal = 10000; // Adjust the delay time in milliseconds
            setTimeout(() => {
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            }, delayBeforeClosingModal);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
const quantityContainer = document.querySelector(
  ".quantity-selector-container"
);
if (quantityContainer) {
  const quantityMinusButtons = document.querySelectorAll(".quantity-minus");
  const quantityPlusButtons = document.querySelectorAll(".quantity-plus");

  let timeoutId = null;
  function handleQuantityChange(productForm) {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      const quantityInput = productForm.querySelector('input[name="quantity"]');
      const newQuantity = parseInt(quantityInput.value);
      const hiddenInput = document.querySelector(".product-variant-id");
      const value_1 = parseInt(hiddenInput.value);
      let updates = {
        [value_1]: newQuantity,
      };

      // Make the fetch call to update the quantity using the stored line number
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          // ... (handle the updated cart data)
        })
        .catch((error) => {
          // ... (handle errors)
        });
    }, 300);
  }

  quantityMinusButtons.forEach((button) => {
    if (button.classList.contains("listener-added")){
      }else{
      button.classList.add("listener-added");
      button.addEventListener("click", () => {
        const productForm = button.closest(".product-form");
        const quantityInput = productForm.querySelector('input[name="quantity"]');
        let quantity = parseInt(quantityInput.value);
  
        if (quantity > 0) {
          quantity--;
          quantityInput.value = quantity;
        }
  
        handleQuantityChange(productForm);
      });
    }
  });

    quantityPlusButtons.forEach((button) => {
      if (button.classList.contains("listener-added")){
      }else{
        button.classList.add("listener-added");
        button.addEventListener("click", () => {
          const productForm = button.closest(".product-form");
          const quantityInput = productForm.querySelector('input[name="quantity"]');
          let quantity = parseInt(quantityInput.value);
          quantity++;
          quantityInput.value = quantity;
          handleQuantityChange(productForm);
        
        });
      }
    });
  
  }
